import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import { alllanguage } from "../../data/lang";
import { Ilanguage } from "../../core/interface/Icommon";
import withIntroductionConfiguration from "./configuration/withIntroductionConfiguration";
import { actions as introductionActions } from "../../gamereducer/introductionPageReducer";
import { isMobile } from "react-device-detect";
import { actions as applicationActions } from "../../core/reducers/applicationStateReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import { actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { TIMER } from "../../core/utills";


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class IntroductionInCanvas extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected introductionContainer: _ReactPixi.IContainer | Ref<any>;
    private allLanguage: Ilanguage;
    private introductionContainerHolder: any;
    private backgroundImagePortrait: any;
    private backgroundImage: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected scalingOfPortraitBg: number = 0.8;
    protected xCoordinateOfPortraitBg: number = -228;
    protected yCoordinateOfPortraitBg: number = 203;
    protected timerAmount: number = 200;
    private minFullHDWidth: number = 1024;
    private HDReadyWidth: number = 1280;
    private fullHDWidth: number = 1920;
    private minFullHDPxRatio: number = 2;
    private canvasBgImagePage: string = "";
    private tweenTimer: number = 0.001;
    private pageOneTimer: any;
    private pageTwoTimer: any;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.allLanguage = alllanguage;
        this.state = {
            uiElements: [],
            lang: "en",
            width: this.props.width,
            height: this.props.height,
            pixelRatio: window.devicePixelRatio,
            resizing: false,
            introPageSelected: 1,
            dotDisable1: false,
            dotDisable2: true
        }
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }
        this.introductionContainer = React.createRef();
        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));


    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    updateDimensions = (arg: any) => {
        if (arg === "Resized") {
            this.calculateCanvas();
        }
    };

    handleResizeChangeInIframe() {

        let
            width = 0,
            height = 0,
            scaleX = 0,
            scaleY = 0,
            scaleFactor = 0,
            viewWidth,
            viewHeight;
        let viewportWidth, viewportHeight: any, dpr;

        if (this.props.detectDevices.isAndroidMobile()) {
            if (window.devicePixelRatio > 2) {
                dpr = 1;// Math.min(window.devicePixelRatio, 2);
            } else {
                dpr = window.devicePixelRatio;
            }

        } else {
            dpr = window.devicePixelRatio;
        }

        // pixel ratios greater that 2 on some android devices mess up


        if (isMobile) {
            if (window.outerHeight > window.outerWidth) {

                viewportWidth = this.props.constant.configGame.portraitCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.portraitCanvasHeight * dpr;
            } else {

                viewportWidth = this.props.constant.configGame.landscapeCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.landscapeCanvasHeight * dpr;
            }
        } else {
            viewportWidth = this.props.constant.configGame.canvasWidth;
            viewportHeight = this.props.constant.configGame.canvasHeight;

        }

        //isMobile
        if (this.props.detectDevices.isHandheld() === true && this.props.detectDevices.isSafariBrowser() === false) {
            if (this.props.detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.outerWidth;
                viewHeight = window.outerHeight;
            } else {
                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }

        scaleFactor = viewHeight / viewportHeight;
        if (Math.round(scaleFactor * viewportWidth) > viewWidth) {
            width = viewWidth;
            scaleX = viewWidth / viewportWidth;

            height = Math.ceil(scaleX * viewportHeight);
            scaleY = scaleX;
        } else {
            height = viewHeight;
            scaleY = viewHeight / viewportHeight;

            width = Math.ceil(scaleY * viewportWidth);
            scaleX = scaleY;
        }


        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {

                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {

                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            if (UIManager.getRef("introductionContainer") && this.props.showIntroductionPage) {
                UIManager.getRef("introductionContainer").scale.x = (width * dpr) / Can_Width
                UIManager.getRef("introductionContainer").scale.y = (height * dpr) / Can_Height
            }

        }

    }

    handleResizeChange() {

        let
        width = 0,
        height = 0,
        scaleX = 0,
        scaleY = 0,
        scaleFactor = 0,
        viewWidth,
        viewHeight;
    let viewportWidth, viewportHeight: any, dpr;

    if (this.props.detectDevices.isAndroidMobile()) {
        if (window.devicePixelRatio > 2) {
            dpr = Math.min(window.devicePixelRatio, 2);
        } else {
            dpr = window.devicePixelRatio;
        }

    } else {
        dpr = window.devicePixelRatio;
    }



    if (isMobile) {
        if (window.innerHeight > window.innerWidth) {

            viewportWidth = this.props.constant.configGame.portraitCanvasWidth * dpr;
            viewportHeight = this.props.constant.configGame.portraitCanvasHeight * dpr;
        } else {

            viewportWidth = this.props.constant.configGame.landscapeCanvasWidth * dpr;
            viewportHeight = this.props.constant.configGame.landscapeCanvasHeight * dpr;
        }
    } else {
        viewportWidth = this.props.constant.configGame.canvasWidth;
        viewportHeight = this.props.constant.configGame.canvasHeight;

    }

        //isMobile
        if (this.props.detectDevices.isHandheld() === true && this.props.detectDevices.isSafariBrowser() === false) {
            if (this.props.detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            } else {
                viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }
        scaleFactor = viewHeight / viewportHeight;
        if (Math.round(scaleFactor * viewportWidth) > viewWidth) {
            width = viewWidth;
            scaleX = viewWidth / viewportWidth;

            height = Math.ceil(scaleX * viewportHeight);
            scaleY = scaleX;
        } else {
            height = viewHeight;
            scaleY = viewHeight / viewportHeight;

            width = Math.ceil(scaleY * viewportWidth);
            scaleX = scaleY;
        }
        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {

                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {

                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            if (UIManager.getRef("introductionContainer") && this.props.showIntroductionPage) {
                UIManager.getRef("introductionContainer").scale.x = (width * dpr) / Can_Width
                UIManager.getRef("introductionContainer").scale.y = (height * dpr) / Can_Height
            }

        }

    }

    //to scale canvas according to mobile
    scalingOfCanvasForMobile(width: any, height: any) {
        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                Can_Width = this.props.constant.configGame.portraitCanvasHeight;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
                this.backgroundImagePortrait.scale.x += (width * window.devicePixelRatio) / (Can_Width * this.props.scaleY);
                this.backgroundImagePortrait.scale.y += (height * window.devicePixelRatio) / Can_Height;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            this.introductionContainerHolder && (this.introductionContainerHolder.scale.x = (width * window.devicePixelRatio) / Can_Width);
            this.introductionContainerHolder && (this.introductionContainerHolder.scale.y = (height * window.devicePixelRatio) / Can_Height);
        }
    }

    iniFrame() {
        if (window.location !== window.parent.location) {

            // The page is in an iFrames
            //  document.write("The page is in an iFrame");
            return true
        } else {

            // The page is not in an iFrame
            // document.write("The page is not in an iFrame");
            return false
        }
    }

    //this method will call handle Resize change function
    calculateCanvas() {
        if (this.iniFrame()) {
            this.handleResizeChange()
        } else {
            this.handleResizeChangeInIframe()
        }
        UIManager.getRef("Text_WinMultiplier") && UIManager.setText("Text_WinMultiplier", this.props.langObj["introductionText_7"])

    }

    componentDidMount() {
        UIManager.getRef("Text_WinMultiplier") && UIManager.setText("Text_WinMultiplier", this.props.langObj["introductionText_7"])
        this.layoutChange(this.props.layoutMode);
        this.chooseAssets();
        window.addEventListener('resize', this.updateDimensions);
        let resizeTimeout: any;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(this.updateDimensions, 100, "Resized");
        });

        if (this.props.gameBroken) {
            this.props.hideIntroductionPage();
        }
        this.updateDimensions("Resized");
        resizeTimeout = setTimeout(
            () => {
                this.updateDimensions("Resized");

            }
            , this.timerAmount)
        this.setDotButtonVisibility();
    }

    //this method will initialize object to variables
    initializeObjectInVariable() {
        this.backgroundImage = UIManager.getRef("backgroundImageOfIntroductionPage");
        this.backgroundImagePortrait = UIManager.getRef("backgroundImageOfIntroductionPage_portrait");

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {


        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("backgroundImageOfIntroductionPage") && (UIManager.getRef("backgroundImageOfIntroductionPage").visible = false);
            UIManager.getRef("backgroundImageOfIntroductionPage_portrait") && (UIManager.getRef("backgroundImageOfIntroductionPage_portrait").visible = true);
            UIManager.getRef("backgroundBlackImageForPortrait") && (UIManager.getRef("backgroundBlackImageForPortrait").visible = true);
            UIManager.getRef("landscapeContent") && (UIManager.getRef("landscapeContent").visible = false);
            UIManager.getRef("portraitContent") && (UIManager.getRef("portraitContent").visible = true);
            UIManager.getRef("randomWild_sym") && (UIManager.getRef("randomWild_sym").scale.set(.65));
            UIManager.getRef("wild_sym") && (UIManager.getRef("wild_sym").scale.set(.65));

        }
        else {
            this.showForLandscape();
        }
        if (!this.props.isGameLoadingOver && !this.props.showIntroductionPage) {
            return
        }


        if (this.props.freegameSpinCountRemaining != undefined) {
            return <></>
        }
        if (this.props.introductionScreenVisible === false) {
            return <></>
        }
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }



    showForLandscape() {
        UIManager.getRef("backgroundImageOfIntroductionPage") && (UIManager.getRef("backgroundImageOfIntroductionPage").visible = true);
        UIManager.getRef("backgroundImageOfIntroductionPage_portrait") && (UIManager.getRef("backgroundImageOfIntroductionPage_portrait").visible = false);
        UIManager.getRef("landscapeContent") && (UIManager.getRef("landscapeContent").visible = true);
        UIManager.getRef("portraitContent") && (UIManager.getRef("portraitContent").visible = false);
        UIManager.getRef("backgroundBlackImageForPortrait") && (UIManager.getRef("backgroundBlackImageForPortrait").visible = false);
        UIManager.getRef("randomWild_sym") && (UIManager.getRef("randomWild_sym").scale.set(1));
        UIManager.getRef("wild_sym") && (UIManager.getRef("wild_sym").scale.set(1));
    }
    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode)
            return false;
        }
        if (nextProps.introductionScreenVisible !== this.props.introductionScreenVisible
            || nextProps.gameBroken !== this.props.gameBroken) {
            if (nextProps.gameBroken) {
                nextProps.hideIntroductionPage();
            }
            return false;
        }

        //if (nextProps.isGameLoadingOver && nextProps.isGameLoadingOver !== this.props.isGameLoadingOver) {
        //    nextProps.showIntroductionPageFun();
        //    return false;
        //}

        if (nextProps.resizeWidth !== this.props.resizeWidth
            || nextProps.resizeHeight !== this.props.resizeHeight

        ) {
            this.resize(nextProps);

            return false;
        }
        if (nextProps.introPageSelected !== this.props.introPageSelected) {
            this.addTransitionTweenBetweenPages();
            return false;
        }
        return true;
    }

    //this function will be called when width or Height resizes
    resize(nextProps: any) {
        if (isMobile) {
            this.introductionContainerHolder && (this.introductionContainerHolder.width = nextProps.resizeHeight);

            if (nextProps.layoutMode === "Portrait") {
                this.introductionContainerHolder && (this.introductionContainerHolder.height = nextProps.resizeWidth);
            } else {
                this.introductionContainerHolder && (this.introductionContainerHolder.height = nextProps.resizeWidth);
            }
        }
    }

    chooseAssets() {
        let screen = window.screen;

        let isFullHD = false;
        if (((screen.width >= this.minFullHDWidth || screen.height >= this.minFullHDWidth) && window.devicePixelRatio >= this.minFullHDPxRatio) ||
            (screen.width >= this.HDReadyWidth || screen.height >= this.HDReadyWidth)) {
            isFullHD = true;
        }
        if (isFullHD) {
            this.canvasBgImagePage = "HD/assets/commongame/basegame_2048.jpg";
        } else {
            this.canvasBgImagePage = "LD/assets/commongame/basegame_2048.jpg";

        }
    }

    tweenTo(object: any, property: any, target: any, time: any, easing: any, onchange: any, oncomplete: any, start?: number) {

        new Tween(
            [object],
            {

                [property]: { start: object[property], end: target }
            },
            time || this.tweenTimer,
            easing,
            false, null, null, null, null, false, onchange, oncomplete
        );

    }

    setDotButtonVisibility() {

        if (this.props.introPageSelected === 1) {
            this.showPageOne()
            this.pageOneTimer = TIMER.TimerManager.createTimer(5000);
            this.pageOneTimer.on('end', (e: any) => {
                e.remove();
                this.addTransitionTweenBetweenPages();
                this.showPageTwo();

                this.pageTwoTimer = TIMER.TimerManager.createTimer(5000);
                this.pageTwoTimer.on('end', (e: any) => {
                    e.remove();
                    this.hideIntroPage()
                })
                this.pageTwoTimer.start()
            })
            this.pageOneTimer.start();
        } else {
            this.showPageTwo()
        }
    }


    addTransitionTweenBetweenPages() {

        let pageContainer: any = UIManager.getRef("transitionContainer")

        if (pageContainer) {

            new Tween(
                [pageContainer],
                {

                    'alpha': { start: 0, end: 1 }
                },
                .3,
                easing.easeLinear,
                false, null, null, null, null, false, onchange, () => {

                    new Tween(
                        [pageContainer],
                        {

                            'alpha': { start: 1, end: 0 }
                        },
                        .3,
                        easing.easeLinear,
                        false, null, null, null, null, false, onchange, () => {

                        }
                    );
                }
            );
        }
    }

    showPageOne() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("dotEnable1_portrait") && (UIManager.getRef("dotEnable1_portrait").visible = true);
            UIManager.getRef("dotEnable2_portrait") && (UIManager.getRef("dotEnable2_portrait").visible = false);
            UIManager.getRef("dotDisable1_portrait") && (UIManager.getRef("dotDisable1_portrait").visible = false);
            UIManager.getRef("dotDisable2_portrait") && (UIManager.getRef("dotDisable2_portrait").visible = true);
        }
        else {
            UIManager.getRef("dotEnable1") && (UIManager.getRef("dotEnable1").visible = true);
            UIManager.getRef("dotEnable2") && (UIManager.getRef("dotEnable2").visible = false);
            UIManager.getRef("dotDisable1") && (UIManager.getRef("dotDisable1").visible = false);
            UIManager.getRef("dotDisable2") && (UIManager.getRef("dotDisable2").visible = true);
        }

        let timer = TIMER.TimerManager.createTimer(350);
        timer.on('end', (e: any) => {
            e.remove();
            if (isMobile && window.innerWidth < window.innerHeight) {

                UIManager.getRef("postIntro_Page1Mob") && (UIManager.getRef("postIntro_Page1Mob").visible = true);
                UIManager.getRef("postIntro_Page2Mob") && (UIManager.getRef("postIntro_Page2Mob").visible = false);
            }
            else {
                UIManager.getRef("postIntro_Page1") && (UIManager.getRef("postIntro_Page1").visible = true);
                UIManager.getRef("postIntro_Page2") && (UIManager.getRef("postIntro_Page2").visible = false);
            }

        })
        timer.start();

    }

    showPageTwo() {
        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("dotEnable2_portrait") && (UIManager.getRef("dotEnable2_portrait").visible = true);
            UIManager.getRef("dotEnable1_portrait") && (UIManager.getRef("dotEnable1_portrait").visible = false);
            UIManager.getRef("dotDisable1_portrait") && (UIManager.getRef("dotDisable1_portrait").visible = true);
            UIManager.getRef("dotDisable2_portrait") && (UIManager.getRef("dotDisable2_portrait").visible = false);
        }

        else {
            UIManager.getRef("dotEnable2") && (UIManager.getRef("dotEnable2").visible = true);
            UIManager.getRef("dotEnable1") && (UIManager.getRef("dotEnable1").visible = false);
            UIManager.getRef("dotDisable1") && (UIManager.getRef("dotDisable1").visible = true);
            UIManager.getRef("dotDisable2") && (UIManager.getRef("dotDisable2").visible = false);
        }

        let timer = TIMER.TimerManager.createTimer(350);
        timer.on('end', (e: any) => {
            e.remove();
            if (isMobile && window.innerWidth < window.innerHeight) {
                UIManager.getRef("postIntro_Page1Mob") && (UIManager.getRef("postIntro_Page1Mob").visible = false);
                UIManager.getRef("postIntro_Page2Mob") && (UIManager.getRef("postIntro_Page2Mob").visible = true);
            }
            else {
                UIManager.getRef("postIntro_Page1") && (UIManager.getRef("postIntro_Page1").visible = false);
                UIManager.getRef("postIntro_Page2") && (UIManager.getRef("postIntro_Page2").visible = true);
            }

        })
        timer.start();

    }

    hideIntroPage() {
        (document.getElementsByClassName("canvasBgImage")[0] as any).src = this.canvasBgImagePage;
        this.props.playSound([{ name: "continueButtonSound", loop: false }]);
        let introContainer: any = UIManager.getRef("introductionContainer");
        if (introContainer) {
            this.tweenTo(introContainer, 'alpha',
                0
                , 0.1, "easeInCubic", null, () => {
                    this.props.hideIntroductionPage();
                });
        }


    }

    //this method will be called when a button gets clicked
    handleEvent = (e: any) => {

        this.pageOneTimer && this.pageOneTimer.remove()
        this.pageTwoTimer && this.pageTwoTimer.remove()
        if (e.target.name === "postIntro_continueButton" || e.target.name === "postIntro_continueButtonPortrait") {
            this.hideIntroPage();
        }
        if (e.target.name === "radio_button_on") {
            UIManager.getRef("radio_button_on").visible = false;
            UIManager.getRef("radio_button_off").visible = true;
            this.props.visibleIntroductionScreen(false);
            this.hideIntroOnTimerFade();
        }
        if (e.target.name === "radio_button_off") {
            UIManager.getRef("radio_button_on").visible = true;
            UIManager.getRef("radio_button_off").visible = false;
            this.props.visibleIntroductionScreen(true);
            this.hideIntroOnTimerFade();
        }

        if (e.target.name === "radio_button_on_mobilePortrait") {
            UIManager.getRef("radio_button_on_mobilePortrait").visible = false;
            UIManager.getRef("radio_button_off_mobilePortrait").visible = true;
            this.props.visibleIntroductionScreen(false);
            this.hideIntroOnTimerFade();
        }
        if (e.target.name === "radio_button_off_mobilePortrait") {
            UIManager.getRef("radio_button_on_mobilePortrait").visible = true;
            UIManager.getRef("radio_button_off_mobilePortrait").visible = false;
            this.props.visibleIntroductionScreen(true);
            this.hideIntroOnTimerFade();
        }
    }

    hideIntroOnTimerFade() {
        this.pageTwoTimer = TIMER.TimerManager.createTimer(5000);
        this.pageTwoTimer.on('end', (e: any) => {
            e.remove();
            this.hideIntroPage()
        })
        this.pageTwoTimer.start()
    }

    handleEvent_ = (e: any) => {
        if (e.target.name === "postIntro_continueButton_desktop" || e.target.name === "postIntro_continueButton_mobile") {
            (document.getElementsByClassName("canvasBgImage")[0] as any).src = this.canvasBgImagePage;
            this.props.playSound([{ name: "continueButtonSound", loop: false }]);
            this.props.hideIntroductionPage();
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        this.initializeObjectInVariable();
        this.updateDimensions("Resized");
        let pageContainer: any = UIManager.getRef("transitionContainer")
        pageContainer && (pageContainer.alpha = 0);
        if (isMobile && window.innerWidth < window.innerHeight) {
            this.backgroundImagePortrait && (this.backgroundImagePortrait.visible = true);
            this.backgroundImage && (this.backgroundImage.visible = false);
            this.layoutChange(this.props.layoutMode);

            UIManager.getRef("assetsContainerOfIntroWithoutBg") && (UIManager.getRef("assetsContainerOfIntroWithoutBg").scale.x = this.scalingOfPortraitBg);
            UIManager.getRef("assetsContainerOfIntroWithoutBg") && (UIManager.getRef("assetsContainerOfIntroWithoutBg").scale.y = this.scalingOfPortraitBg);
        }
        if (isMobile && window.innerWidth > window.innerHeight) {
            this.backgroundImagePortrait && (this.backgroundImagePortrait.visible = false);
            this.backgroundImage && (this.backgroundImage.visible = true);
        }

        if (this.props.introPageSelected === 1) {
            this.props.changeIntroPagination(1);
            this.showPageOne()
            //this.addTransitionTweenBetweenPages();
            let pageContainer: any = UIManager.getRef("transitionContainer")
            pageContainer && (pageContainer.alpha = 0);
        }

        if (this.props.introPageSelected === 2) {
            this.props.changeIntroPagination(2);
            this.showPageTwo()
            //this.addTransitionTweenBetweenPages();
        }
    }

    render() {

        if (!this.props.isGameLoadingOver && !this.props.showIntroductionPage) {
            return <></>
        }
        if (this.props.freegameSpinCountRemaining != undefined && this.props.freegameSpinCountRemaining > 0) {
            // this.props.hideIntroductionPage();
            return <></>
        }


        if (this.props.introductionScreenVisible === false) {
            return <></>
        }

        if (this.props.detectDevices.isAndroidMobile()) {
            return <></>
        }
        return (
            <UIManager
                visible={((this.props.showIntroductionPage))}
                //  visible={((this.props.showIntroductionPage) && (this.props.freegameSpinCountRemaining==undefined || this.props.freegameSpinCountRemaining==0)? true : false)  }
                id={"introductionContainer"} name={"introductionContainer"} type={"Container"}
                configGame={this.props.configGame}
                ref={i => this.introductionContainer = i}>

                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-Introduction-${Math.random()}`} langObj={this.props.langObj}
                            type={i.type}
                            id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent}
                            configGame={this.props.configGame} />)
                }

            </UIManager>
        );
    }


}

export default withPixiApp(connect(
    (state: Pick<IStore, 'introductionState' | 'applicationState' | 'freegameState' | 'asyncInitAction'>): IStateToProps =>
    ({

        showIntroductionPage: state.introductionState.showIntroductionPage,
        introPageSelected: state.introductionState.introPageSelected,
        isGameLoadingOver: state.applicationState.isLoading,
        layoutMode: state.applicationState.layoutMode,
        resizeWidth: state.applicationState.resizeWidth,
        resizeHeight: state.applicationState.resizeHeight,
        scaleX: state.applicationState.scaleX,
        introductionScreenVisible: state.introductionState.introductionScreenVisible,
        scaleY: state.applicationState.scaleY,
        freegameSpinCountRemaining: state.freegameState.freegameSpinCountRemaining,
        gameBroken: state.asyncInitAction.gameBroken,


    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        hideIntroductionPage: (): any => dispatch(introductionActions.hideIntroductionPage()),
        changeIntroPagination: (pageNum: number): any => dispatch(introductionActions.changeIntroPagination(pageNum)),
        showIntroductionPageFun: (): any => dispatch(introductionActions.introductionPageShow()),
        setApplicationLayoutMode: (layout: string): any => dispatch(applicationActions.setApplicationLayoutMode(layout)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        visibleIntroductionScreen: (value: boolean): any => dispatch(introductionActions.visibleIntroductionScreen(value)),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
    }))(withIntroductionConfiguration(IntroductionInCanvas)));